/**
 * Is a column's Display Name one the user has cleared?
 *
 * Only a string with nothing in it counts. `null` / `undefined` mean the name
 * was never set — the column shows its own field name, which is fine. A blank
 * string is a name that was deleted and not replaced: the Columns panel marks
 * it required and the editor will not Save or Publish while one exists.
 *
 * One helper for both, so the box that is red and the button that is held
 * always agree.
 */
export const isBlankDisplayName = (value) => typeof value === "string" && value.trim() === "";

/**
 * The first column across the board's resources whose Display Name is blank,
 * as { resourceName, fieldName } — or null when there is none.
 */
export function findBlankDisplayName(resourceList) {
  for (const resource of resourceList || []) {
    for (const field of resource?.availableFields || []) {
      if (isBlankDisplayName(field?.fieldDisplayName)) {
        return { resourceName: resource?.name || resource?.source?.name || "", fieldName: field.fieldName || "" };
      }
    }
  }
  return null;
}
